import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'
import { displayColorBySituation } from '@/utils/common'
import moment from 'moment'
import modalHistoricoSituacaoModule from './modal-historico-situacao.module'

@Component({
  ...modalHistoricoSituacaoModule,
})
export default class ComponentModalHistoricoGeracaoRepasse extends Vue {
  activeTab = 'tab-0'

  close() {
    this.getShowModalHistorico = false
  }

  get historyGeracao() {
    return this.getHistoricoSituacaoStore.historicoGeracaoRepasse
  }

  get getHistoricoSituacaoStore() {
    return getModule(HistoricoSituacaoStore, this.$store)
  }

  get getShowModalHistorico() {
    return this.getHistoricoSituacaoStore.modalHistoricoGeracaoRepasse.historicoGeracaoRepasse
  }

  set getShowModalHistorico(value: boolean) {
    this.getHistoricoSituacaoStore.clearhistoricoSituacao()
    this.getHistoricoSituacaoStore.setShowModalHistoricoGeracaoRepasse(value)
  }

  formatData(date: Date | string) {
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  displayCorSituacao(value: any) {
    return displayColorBySituation(value.tipoLog === 'Situacao' ? value.situacao.key : value.tipoNotificacao.key)
  }
}
